module.exports = "/images/logo.jpg?e6037128bde233008c0902b601106366";